<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonEditMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'edit'">
            <div class="card">
                <div class="card-body">
                    <em-entity-edit-form ref="emEntityEditForm" :entity="modelName"
                                         :return-path="returnPath"
                                         :$_em-custom-vuex-mixin_entity="entityState"></em-entity-edit-form>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
// Author liang gang qiang
// Date 2021-10-13 14:13:23

import emCommonEditMixin from "@/mixin/em/common/edit";
import emUtils from "@/utils/emUtils";

export default {
    name: "mintalMesPrdProductionResultEditView",
    mixins: [emCommonEditMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        entityState() {
            return this.$route.query.hasOwnProperty('entityState') ? this.$route.query.entityState : 'entity';
        },
        returnPath() {
            return "/mintalMes/prd/mintalMesPrdProduction" +
                (emUtils.toCapFirst(this.entityState.substring(0, this.entityState.lastIndexOf('Entity')))) + "ResultList";
        }
    }
};
</script>